module.exports = __webpack_public_path__ + "static/img/1.9fc2594.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/1.png
// module id = 0aiA
// module chunks = 0